export default function StepHeader(props) {
    const { Icon } = props;
    return (
        <>
            <div className={props.className} data-target={props.target}>
                <button type="button" className="step-trigger" onClick={props.onClick}>
                    <span className={"bs-stepper-circle " + props.backgroundColor}>
                        <Icon />
                    </span>
                    <span className="bs-stepper-label">
                        <span className="bs-stepper-title">{props.title}</span>
                        <span className="bs-stepper-subtitle">{props.subTitle}</span>
                    </span>
                </button>
            </div >
            <div className="line"></div>
        </>);
}